import {ActionCreatorDefinition, createAction} from "redux-ts";
import {AuthStatus} from "core/redux/auth/AuthReduxState";
import {NXEnvironmentType} from "platform/protocol/enum/NXEnvironmentType";
import {LoginResponse} from "protocol/auth/LoginResponse";

export const HandleLoginResponseType: string =  "HandleLoginResponse";
export const SetAuthStatusType: string =  "SetAuthStatus";
export const DoLogoutConfirmationType: string =  "DoLogoutConfirmation";
export const DoLogoutType: string =  "DoLogout";
export const DoLogOffType: string =  "DoLogOff";
export const OnLoggedOutType: string =  "OnLoggedOut";
export const DoSwitchAccountType: string =  "DoSwitchAccount";
export const OnAccountChangedType: string =  "OnAccountChanged";
export const DoChangePasswordType: string =  "DoChangePassword";
export const SetChangePasswordErrorType: string =  "SetChangePasswordError";

export interface HandleLoginResponsePayload {

    response: LoginResponse;
    username: string;
    password: string;
}

export interface SetAuthStatusPayload {

    authStatus: AuthStatus;
}

export interface DoLogoutPayload {

    skipNotifyServer?: boolean;
}

export interface DoSwitchAccountPayload {

    accountType: NXEnvironmentType;
}

export interface DoChangePasswordPayload {

    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export interface SetChangePasswordErrorPayload {

    errorMsg: string;
}

export const HandleLoginResponse: ActionCreatorDefinition<HandleLoginResponsePayload, any> = createAction<HandleLoginResponsePayload>(HandleLoginResponseType);
export const SetAuthStatus: ActionCreatorDefinition<SetAuthStatusPayload, any> = createAction<SetAuthStatusPayload>(SetAuthStatusType);
export const DoLogoutConfirmation: ActionCreatorDefinition<any, any> = createAction<any>(DoLogoutConfirmationType);
export const DoLogout: ActionCreatorDefinition<DoLogoutPayload, any> = createAction<DoLogoutPayload>(DoLogoutType);
export const DoLogOff: ActionCreatorDefinition<any, any> = createAction<any>(DoLogOffType);
export const OnLoggedOut: ActionCreatorDefinition<any, any> = createAction<any>(OnLoggedOutType);
export const DoSwitchAccount: ActionCreatorDefinition<DoSwitchAccountPayload, any> = createAction<DoSwitchAccountPayload>(DoSwitchAccountType);
export const OnAccountChanged: ActionCreatorDefinition<any, any> = createAction<any>(OnAccountChangedType);
export const DoChangePassword: ActionCreatorDefinition<DoChangePasswordPayload, any> = createAction<DoChangePasswordPayload>(DoChangePasswordType);
export const SetChangePasswordError: ActionCreatorDefinition<SetChangePasswordErrorPayload, any> = createAction<SetChangePasswordErrorPayload>(SetChangePasswordErrorType);
